import { Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { type SupplierSyncStatus } from 'src/core/modules/suppliers/hooks';

import {
  getAccountPayableSuppliersCalloutContent,
  getAccountPayableSuppliersTitle,
} from './translations';
import { SupplierOrMemberSyncStatus } from '../../../components/SupplierOrMemberSyncStatus/SupplierOrMemberSyncStatus';
import { type AccountingSoftware } from '../../../integration/status';

export const AccountPayableSuppliersSyncStatus = ({
  syncStatus,
  integrationName,
}: {
  syncStatus: SupplierSyncStatus;
  integrationName: AccountingSoftware;
}) => {
  const { t } = useTranslation('global');

  if (syncStatus.synced) {
    return (
      <SupplierOrMemberSyncStatus
        label={getAccountPayableSuppliersTitle(integrationName, t)}
        {...syncStatus}
      />
    );
  }

  const { title, text } = getAccountPayableSuppliersCalloutContent(
    integrationName,
    t,
  );

  return (
    <Callout title={title} variant="warning">
      <p>{text}</p>
    </Callout>
  );
};
